package com.shadowings.gero.presentation.viewmodel

import androidx.lifecycle.SavedStateHandle
import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.shadowings.gero.data.datasource.compendioRules
import com.shadowings.gero.domain.model.CompendioRuleItem
import com.shadowings.gero.domain.model.UserData
import com.shadowings.gero.domain.repository.UserDataRepository
import kotlinx.coroutines.flow.SharingStarted
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.stateIn

class RuleDetailViewModel(
    savedStateHandle: SavedStateHandle,
    private val userDataRepository: UserDataRepository,
) : ViewModel() {

    val ruleId: String = savedStateHandle.get<String>("ruleId") ?: ""

    val rule: CompendioRuleItem? = compendioRules.find { it.id == ruleId }

    val userData: StateFlow<UserData> = userDataRepository.userData
        .stateIn(viewModelScope, SharingStarted.Eagerly, UserData())
}
